module.exports = __webpack_public_path__ + "static/img/6002.dfcb5095.png";